import { faInstagram, faLinkedin } from "@fortawesome/free-brands-svg-icons";
import { faGlobe } from "@fortawesome/free-solid-svg-icons";
import RituMam from "../assets/RituMam.jpeg";
// 2024 Event Data
export const sponsors2024 = [
  {
    name: "Excel Overseas",
    link: "https://www.exceloverseas.net/",
    image: "/sponsors/excel_logo.png",
  },
  {
    name: "Tempt",
    link: "https://wearemandys.com",
    image: "/sponsors/mandys.png",
  },
  {
    name: "Taiyo",
    link: "#",
    image: "/sponsors/taiyo.jpg",
  },
];

export const speakers2024 = [
  {
    name: "Mr. Aakash Bhavsar",
    position: "Digital Creator",
    image:
      "https://res.cloudinary.com/djyqufw6g/image/upload/v1710063343/powertrainfinal_yv9bf8.png",
    text: [
      `Aka Powertrain, he endeavours to bring out the nitty-gritty of infrastructure to all, making it a mainstream of discussion and not just the topic left for experts. `,
    ],

    list: [`Media Company Owner`, `YouTuber`, `Content Creator`],
  },
  {
    name: "Mr. Saurabh Bhosale",
    position: "Humourist",
    image:
      "https://res.cloudinary.com/djyqufw6g/image/upload/v1710168808/sbfinal_jkexcu.png",
    text: [
      `Either he'll make you laugh or he'll make you think. He is famous for his story telling skills with his exceptional taste in sense of humour.`,
    ],

    list: [
      `Founder of Project Visioncy & Company Of Content`,
      "Represented India  at World Youth Summit",
      `Storyteller`,
      `Humourist`,
    ],
  },
  {
    name: "Mr. Sharif Bapu",
    position: "President of MMA India",
    image:
      "https://res.cloudinary.com/djyqufw6g/image/upload/v1710170651/mmafinal_pexedv.png",
    text: [
      `He is the esteemed President of MMA India, and runs the academy of self defence with life long passion for martial arts empowering women for self-defense training, leaving his lasting impact nationally and internationally.`,
    ],

    list: [
      `Director of Sports MMA India`,
      "Chairman of International MMA Federation",
      "President of MMA India",
    ],
  },
  {
    name: "Ms.Kanika Rajput",
    position: "Leader & Entrepreneur",
    image:
      "https://res.cloudinary.com/djyqufw6g/image/upload/v1710269041/Kanikafinal_juuljd.png",
    text: [
      "She is a dynamic leader closely collaborating with the Government of India on transformative initiatives. At just 24, she pioneered the establishment of the National Land Monetization Company.",
    ],
    list: [
      "Founder of Nav-Tarang",
      "Pioneered National Land Monetization Company",
      "One of the Youngest Leaders of India",
    ],
  },
  {
    name: "Dr. Roy Kshemendra",
    position: "Marketing Expert",
    image:
      "https://res.cloudinary.com/djyqufw6g/image/upload/v1710271216/Roy_i9mg00.png",
    text: [
      `He is a seasoned professional in marketing and brand management. His expertise lies in communications, behavioral science, and reputation management. `,
    ],

    list: [
      `Head of Communications & Customer Centricity Agency Business at Tata AIA.`,
      `Head Centre for Behaviroal Science at IIMA`,
      `Marketing Head at TATA Sons Limited`,
    ],
  },
];

export const heads2024 = [
  {
    image: RituMam,
    name: "Ritu S.",
    position: "Faculty Coordinator",
    social: [
      faLinkedin,
      "https://www.linkedin.com/in/dr-ritu-sharma-b87a1544/?originalSubdomain=in",
    ],
  },

  {
    image:
      "https://res.cloudinary.com/djyqufw6g/image/upload/v1709159105/Yash_Mahtkar_gtasuv.png",
    name: "Yash M.",
    position: "Licensee",
    social: [faLinkedin, "https://in.linkedin.com/in/yash-mathkar-b91441237"],
  },
  {
    image:
      "https://res.cloudinary.com/tedxace/image/upload/v1675337277/2023/Om_Bhamare_wzvifg.jpg",
    name: "Om B.",
    position: "Co-Organizer",
    social: [faLinkedin, "https://in.linkedin.com/in/om-bhamare-1042251b6"],
  },
];

export const curator2024 = [
  {
    image:
      "https://res.cloudinary.com/tedxace/image/upload/v1675337279/2023/Aarnav_Sangekar_qsrf8b.jpg",
    name: "Arnav S.",
    position: "Curator",
    social: [faLinkedin, "https://in.linkedin.com/in/aarnav-sangekar"],
  },
  {
    image:
      "https://res.cloudinary.com/djyqufw6g/image/upload/v1709234816/Shamit_Shetty_dwpy4a.jpg",
    name: "Shamit S.",
    position: "Curator",
    social: [faLinkedin, "https://www.linkedin.com/in/shamit-shetty/"],
  },
  {
    image:
      "https://res.cloudinary.com/djyqufw6g/image/upload/v1709235036/Aayushi_Tandale_nr3ama.jpg",
    name: "Aayushi T.",
    position: "Curator",
    social: [faInstagram, "https://www.instagram.com/iyyushe/"],
  },
  {
    image:
      "https://res.cloudinary.com/tedxace/image/upload/v1675337280/2023/Nishit_Prabhu__msumbo.jpg",
    name: "Nishit P.",
    position: "Curator",
    social: [faLinkedin, "https://www.linkedin.com/in/nishit-prabhu/"],
  },
  {
    image:
      "https://res.cloudinary.com/tedxace/image/upload/v1675337278/2023/Soham_Rane_vr7fmc.jpg",
    name: "Soham R.",
    position: "Curator",
    social: [faLinkedin, "https://in.linkedin.com/in/soham-rane-150109135"],
  },
  {
    image:
      "https://res.cloudinary.com/tedxace/image/upload/v1675337278/2023/Shivam_ylypox.jpg",
    name: "Shivam W.",
    position: "Curator",
    social: [
      faLinkedin,
      "https://www.linkedin.com/in/shivam-whatkar-699b46199",
    ],
  },
];

export const market2024 = [
  {
    image:
      "https://res.cloudinary.com/djyqufw6g/image/upload/v1709237574/Screenshot_20240229_211616_LinkedIn_bn7wnt.jpg",
    name: "Fariha S.",
    position: "Marketing",
    social: [faInstagram, "https://www.instagram.com/fariha.shk/"],
  },
  {
    image:
      "https://res.cloudinary.com/djyqufw6g/image/upload/v1709234816/Shamit_Shetty_dwpy4a.jpg",
    name: "Shamit S.",
    position: "Marketing",
    social: [faLinkedin, "https://www.linkedin.com/in/shamit-shetty/"],
  },
  {
    image:
      "https://res.cloudinary.com/djyqufw6g/image/upload/v1709237790/Prerna_dq0e7p.jpg",
    name: "Prerna J.",
    position: "Marketing",
    social: [faInstagram, "https://www.instagram.com/prerna_jadhav33/"],
  },
  {
    image:
      "https://res.cloudinary.com/djyqufw6g/image/upload/v1709235036/Aayushi_Tandale_nr3ama.jpg",
    name: "Aayushi T.",
    position: "Marketing",
    social: [faInstagram, "https://www.instagram.com/iyyushe/"],
  },
  {
    image:
      "https://res.cloudinary.com/djyqufw6g/image/upload/v1709238077/Soham_Pujari_vpgu2o.jpg",
    name: "Soham P.",
    position: "Marketing",
    social: [faInstagram, "https://www.instagram.com/soham21__/"],
  },
  {
    image:
      "https://res.cloudinary.com/djyqufw6g/image/upload/v1709238235/Aryan_Shetty_ledtqm.jpg",
    name: "Aryan S.",
    position: "Marketing",
    social: [faInstagram, "https://www.instagram.com/shettyaryan01/"],
  },
];

export const decor2024 = [
  {
    image:
      "https://res.cloudinary.com/djyqufw6g/image/upload/v1709239002/Manasi_powar_wxd0wl_cmygot.jpg",
    name: "Manasi P.",
    position: "Decor",
    social: [faInstagram, "https://instagram.com/_manasiiiiii_"],
  },
  {
    image:
      "https://res.cloudinary.com/djyqufw6g/image/upload/v1709058354/Ashvin_dige_qwvh8z.jpg",
    name: "Ashvin D.",
    position: "Decor",
    social: [faLinkedin, "https://www.linkedin.com/in/ashvin-dige-b00700251/"],
  },
  {
    image:
      "https://res.cloudinary.com/djyqufw6g/image/upload/v1709239208/Jaydeep_ysdisl.jpg",
    name: "Jaydeep J.",
    position: "Decor",
    social: [faInstagram, "https://www.instagram.com/jd_06_2004/"],
  },
  {
    image:
      "https://res.cloudinary.com/djyqufw6g/image/upload/v1709239506/Gajanan_Ghirnikar_m3vrdu.jpg",
    name: "Gajanan G.",
    position: "Decor",
    social: [faInstagram, "https://www.instagram.com/gajanan__13/"],
  },
  {
    image:
      "https://res.cloudinary.com/djyqufw6g/image/upload/v1709238667/Adharsh_Sajikumar_plto54.jpg",
    name: "Adharsh S.",
    position: "Decor",
    social: [faInstagram, "https://www.instagram.com/adharsh_494/"],
  },
  {
    image:
      "https://res.cloudinary.com/djyqufw6g/image/upload/v1709237790/Prerna_dq0e7p.jpg",
    name: "Prerna J.",
    position: "Decor",
    social: [faInstagram, "https://www.instagram.com/prerna_jadhav33/"],
  },
  {
    image:
      "https://res.cloudinary.com/djyqufw6g/image/upload/v1709239907/Riya_Shetty_wphvsa.jpg",
    name: "Riya S.",
    position: "Decor",
    social: [faInstagram, "https://www.instagram.com/aasya2468/"],
  },
  {
    image:
      "https://res.cloudinary.com/djyqufw6g/image/upload/v1709240276/Sahil_Ligam_ELEC_TE_mpoqn5.jpg",
    name: "Sahil L.",
    position: "Decor",
    social: [faInstagram, "https://www.instagram.com/__sahil._.17/"],
  },
  {
    image:
      "https://res.cloudinary.com/djyqufw6g/image/upload/v1709240373/Dhara_Dhotre_z1slxk.jpg",
    name: "Dhara D.",
    position: "Decor",
    social: [faInstagram, "https://www.instagram.com/dharaa_xoxo/"],
  },
  {
    image:
      "https://res.cloudinary.com/djyqufw6g/image/upload/v1709240484/Shourya_Mayekar_v36b5f.jpg",
    name: "Shourya M.",
    position: "Decor",
    social: [faInstagram, "https://www.instagram.com/__spicy___shorma__/"],
  },
  {
    image:
      "https://res.cloudinary.com/djyqufw6g/image/upload/v1709235815/Riya_Rumde_nz0clz.jpg",
    name: "Riya R.",
    position: "Decor",
    social: [faLinkedin, "https://www.linkedin.com/in/riya-rumde-04740121a"],
  },
  {
    image:
      "https://res.cloudinary.com/djyqufw6g/image/upload/v1709240968/Kaushal_Gawad_vg6vf1.jpg",
    name: "Kaushal G.",
    position: "Decor",
    social: [faInstagram, "https://www.instagram.com/kaushal_1403/"],
  },
];

export const tech2024 = [
  {
    image:
      "https://res.cloudinary.com/tedxace/image/upload/v1675337277/2023/Jamil_Shaikh_xvaomb.png",
    name: "Jamil S.",
    position: "Web Developer",
    social: [faLinkedin, "https://in.linkedin.com/in/shaikhjamil"],
  },
  {
    image:
      "https://res.cloudinary.com/djyqufw6g/image/upload/v1709232481/Omk_a5ysnp.jpg",
    name: "Om K.",
    position: "Web Developer",
    social: [faLinkedin, "https://in.linkedin.com/in/om-kulkarni-174221256"],
  },
  {
    image:
      "https://res.cloudinary.com/djyqufw6g/image/upload/v1709162916/Shivam-Narkar-Web_twxj99.png",
    name: "Shivam N.",
    position: "Web Developer",
    social: [faLinkedin, "https://in.linkedin.com/in/shivam-narkar"],
  },
  {
    image:
      "https://res.cloudinary.com/djyqufw6g/image/upload/v1709058244/Dhruv_Bhatada_ehwiuf.jpg",
    name: "Dhruv B.",
    position: "Web Developer",
    social: [faLinkedin, "https://www.linkedin.com/in/dhruvbhatada/"],
  },
  {
    image:
      "https://res.cloudinary.com/djyqufw6g/image/upload/v1709162995/Yash_Surve_nlcd0m.jpg",
    name: "Yash S.",
    position: "Web Developer",
    social: [faLinkedin, "http://www.linkedin.com/in/yash-surve-244414255"],
  },
  {
    image:
      "https://res.cloudinary.com/djyqufw6g/image/upload/v1709240902/Suhani_Bhansali_e3h5ux.jpg",
    name: "Suhani B.",
    position: "Web Developer",
    social: [
      faLinkedin,
      "https://www.linkedin.com/in/suhani-bhansali-15902b256",
    ],
  },
];

export const designer2024 = [
  {
    image:
      "https://res.cloudinary.com/djyqufw6g/image/upload/v1709236091/Dheeraj_Rapelli_xz8cnm.jpg",
    name: "Dheeraj R.",
    position: "Designer",
    social: [
      faLinkedin,
      "https://www.linkedin.com/in/dheeraj-rapelli-b9a9b3218/",
    ],
  },
  {
    image:
      "https://res.cloudinary.com/djyqufw6g/image/upload/v1709058354/Ashvin_dige_qwvh8z.jpg",
    name: "Ashvin D.",
    position: "Designer",
    social: [faLinkedin, "https://www.linkedin.com/in/ashvin-dige-b00700251/"],
  },
  {
    image:
      "https://res.cloudinary.com/djyqufw6g/image/upload/v1708594734/kundan_kumavat_cxvop2.jpg",
    name: "Kundan K.",
    position: "Designer",
    social: [
      faLinkedin,
      "https://www.linkedin.com/in/kundan-kumavat-547b83206/",
    ],
  },
  {
    image:
      "https://res.cloudinary.com/djyqufw6g/image/upload/v1709235815/Riya_Rumde_nz0clz.jpg",
    name: "Riya R.",
    position: "Designer",
    social: [faLinkedin, "https://www.linkedin.com/in/riya-rumde-04740121a"],
  },
  {
    image:
      "https://res.cloudinary.com/djyqufw6g/image/upload/v1709058244/Dhruv_Bhatada_ehwiuf.jpg",
    name: "Dhruv B.",
    position: "Designer",
    social: [faLinkedin, "https://www.linkedin.com/in/dhruvbhatada/"],
  },
];

export const social2024 = [
  {
    image:
      "https://res.cloudinary.com/tedxace/image/upload/v1675337280/2023/Aarya_Jadhav_hncdks.jpg",
    name: "Aarya J.",
    position: "Social Media",
    social: [faInstagram, "https://instagram.com/_aarya.28"],
  },
  {
    image:
      "https://res.cloudinary.com/djyqufw6g/image/upload/v1709236751/Sneha_sawant_zlvyu2.jpg",
    name: "Sneha S.",
    position: "Social Media",
    social: [faLinkedin, "https://in.linkedin.com/in/sneha-sawant-a1572b262"],
  },
  {
    image:
      "https://res.cloudinary.com/djyqufw6g/image/upload/v1709058085/kundan-thakur_rhq10h.jpg",
    name: "Kundan T.",
    position: "Social Media",
    social: [faInstagram, "https://www.instagram.com/iam_kundan___/"],
  },
  {
    image:
      "https://res.cloudinary.com/djyqufw6g/image/upload/v1709237009/Pratap_Aare_cwrspu.jpg",
    name: "Pratap Aare",
    position: "Social Media",
    social: [faInstagram, "https://www.instagram.com/pratap_aare/"],
  },
];

export const video2024 = [
  {
    image:
      "https://res.cloudinary.com/tedxace/image/upload/v1675337279/2023/Prathmesh_Walavalkar_tyet9u.jpg",
    name: "Prathmesh W.",
    position: "Video Production",
    social: [faGlobe, "https://linktr.ee/PrathmeshWalavalkar"],
  },
  {
    image:
      "https://res.cloudinary.com/djyqufw6g/image/upload/v1709236751/Sneha_sawant_zlvyu2.jpg",
    name: "Sneha S.",
    position: "Video Production",
    social: [faLinkedin, "https://in.linkedin.com/in/sneha-sawant-a1572b262"],
  },
  {
    image:
      "https://res.cloudinary.com/djyqufw6g/image/upload/v1709058085/kundan-thakur_rhq10h.jpg",
    name: "Kundan T.",
    position: "Video Production",
    social: [faInstagram, "https://www.instagram.com/iam_kundan___/"],
  },
  {
    image:
      "https://res.cloudinary.com/djyqufw6g/image/upload/v1709238667/Adharsh_Sajikumar_plto54.jpg",
    name: "Adharsh S.",
    position: "Video Production",
    social: [faInstagram, "https://www.instagram.com/adharsh_494/"],
  },
  {
    image:
      "https://res.cloudinary.com/djyqufw6g/image/upload/v1709162995/Yash_Surve_nlcd0m.jpg",
    name: "Yash S.",
    position: "Video Production",
    social: [faLinkedin, "http://www.linkedin.com/in/yash-surve-244414255"],
  },
];

export const team2024 = [
  { name: "tech", members: [...tech2024] },
  { name: "curator", members: [...curator2024] },
  { name: "designer", members: [...designer2024] },
  { name: "social", members: [...social2024] },
  { name: "market", members: [...market2024] },
  { name: "decor", members: [...decor2024] },
  { name: "video", members: [...video2024] },
];
